import React from 'react';
import styled from 'styled-components';

const Section = styled.section`
  padding: 5rem 1rem;
  background: var(--background-light);
`;

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.05fr 1fr;
  gap: 3rem;
  align-items: center;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const Copy = styled.div`
  color: var(--text-color);

  .tag {
    display: inline-block;
    padding: 0.35rem 0.9rem;
    border-radius: 999px;
    border: 1px solid rgba(255,255,255,0.15);
    background: rgba(0, 153, 0, 0.08);
    color: var(--primary-color);
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 1rem;
  }
  h2 {
    font-size: clamp(1.75rem, 3.2vw, 2.5rem);
    margin: 0 0 1rem;
    span { color: var(--primary-color); }
  }
  p.lede {
    color: var(--text-secondary);
    line-height: 1.7;
    margin: 0 0 1.75rem;
  }
`;

const Points = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    display: flex;
    gap: 0.75rem;
    align-items: flex-start;
    padding: 0.6rem 0;
    color: var(--text-color);
    line-height: 1.5;

    .dot {
      flex: 0 0 24px;
      height: 24px;
      border-radius: 50%;
      background: rgba(0, 153, 0, 0.15);
      color: var(--primary-color);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-weight: 800;
      font-size: 0.85rem;
      margin-top: 2px;
    }
    strong { color: var(--text-color); font-weight: 600; }
    span { color: var(--text-secondary); }
  }
`;

const Media = styled.div`
  border-radius: 1.5rem;
  overflow: hidden;
  border: 1px solid rgba(0, 153, 0, 0.25);
  aspect-ratio: 4/3;
  img { width: 100%; height: 100%; object-fit: cover; display: block; }
`;

const REASONS = [
  { t: 'Multi-chain by default', d: 'TRC-20, ERC-20, BEP-20 — one license, all three networks.' },
  { t: '50+ compatible wallets', d: 'Trust Wallet, MetaMask, Binance, Coinbase, TronLink, SafePal, Exodus and more.' },
  { t: '365-day flash duration', d: 'Long validity windows for realistic long-running demos and QA.' },
  { t: 'One-time purchase', d: 'No monthly fees. Lifetime option for teams that need it forever.' },
  { t: '24/7 WhatsApp support', d: 'Real humans on the other end — activation, wallet quirks, network switching.' },
];

const WhyChoose: React.FC = () => (
  <Section id="why">
    <Inner>
      <Copy>
        <div className="tag">Why choose us</div>
        <h2>Built on <span>real-world requirements</span> from traders, developers, and testers.</h2>
        <p className="lede">
          Everything you need to run credible USDT flows in demos, training, and QA —
          without touching mainnet funds or waiting for expensive testnet gas.
        </p>
        <Points>
          {REASONS.map((r) => (
            <li key={r.t}>
              <span className="dot">✓</span>
              <div><strong>{r.t}</strong> — <span>{r.d}</span></div>
            </li>
          ))}
        </Points>
      </Copy>
      <Media>
        <img src="/img/usdt-wallet.jpg" alt="USDT balance on a crypto wallet interface" />
      </Media>
    </Inner>
  </Section>
);

export default WhyChoose;
